import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ProgrammeService {

    constructor(private http: HttpClient) {
    }

    public getLoyaltySites(): Observable<any> {
        return this.http.get<any>('/api/Programmes/GetSites');
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/DataServices/programme.service.ts